export default {
  setPermissions(state, value) {
    state.permissions = value
  },

  setFetched(state, value) {
    state.fetched = value
  },

  setRoles(state, value) {
    state.roles = value
    // set empty value
    state.roles.unshift({
      id: null,
      value: 'All',
    })
  },

  setServices(state, value) {
    state.services = value
    // set empty value
    state.services.unshift({
      id: null,
      value: 'All',
    })
  },

  setChanges(state, value) {
    state.changes = value
  },

  updatePermission(state, { roleId, serviceId, permission, rules }) {
    const item = state.permissions.find(item => item.role.id === roleId && item.service.id === serviceId)

    if (item) {
      item.permission.value = permission
      item.rules = rules
    }
  },

  remove(state, { roleId, serviceId, rules }) {
    const item = state.permissions.find(item => item.role.id === roleId && item.service.id === serviceId)

    if (item) {
      item.permission.value = 0
      item.rules = rules
    }
  },

  add(state, item) {
    state.permissions.push(item)
  },
}
